import { catchError } from 'rxjs/operators';
import { ApiService } from 'src/app/shared/services/api.service';
import { HelperService } from 'src/app/shared/services/helper.service';
import * as i0 from "@angular/core";
import * as i1 from "./api.service";
import * as i2 from "./helper.service";
var PrivacyStudioDocsService = /** @class */ (function () {
    /**
     * Class constructor
     */
    function PrivacyStudioDocsService(apiService, helperService) {
        this.apiService = apiService;
        this.helperService = helperService;
    }
    /**
     * Create a new privacy studio doc
     *
     * @since 1.0.0
     *
     * @param data PrivacyStudioDoc data
     * @returns Observable<any>
     */
    PrivacyStudioDocsService.prototype.create = function (companyId, data) {
        return this.apiService.apiCall("POST", "companies/privacy-studio-docs/" + companyId, data);
    };
    /**
     * Get privacy studio docs list for given query params
     *
     * @since 1.0.0
     *
     * @param [start] Query left offset
     * @param [limit] Results number
     * @param [sort] Sorting field name
     * @param [sortVersus] Sorting versus. Can be 'asc' or 'desc'
     * @param [search] Filtering object with fildering data string
     */
    PrivacyStudioDocsService.prototype.getList = function (companyId, start, limit, sort, sortVersus, search) {
        var params = { start: start, limit: limit, sort: sort, sortVersus: sortVersus };
        if (search) {
            Object.keys(search).forEach(function (key) {
                var newParamKey = "search[" + key + "]";
                var newParamValue = search[key];
                params[newParamKey] = newParamValue;
            });
        }
        return this.apiService.apiCall('GET', "companies/privacy-studio-docs/" + companyId, params);
    };
    /**
     * Get the privacy studio doc
     *
     * @since 1.0.0
     *
     * @param docId PrivacyStudioDoc Id
     * @returns Observable<any>
     */
    PrivacyStudioDocsService.prototype.get = function (companyId, docId) {
        return this.apiService.apiCall("GET", "companies/privacy-studio-docs/" + companyId + "/" + docId);
    };
    /**
     * Get the privacy studio doc for the public QR-code view page
     *
     * @since 1.0.0
     *
     * @param docId PrivacyStudioDoc Id
     * @returns Observable<any>
     */
    PrivacyStudioDocsService.prototype.getDocByView = function (docId) {
        return this.apiService.apiCall("GET", "companies/privacy-studio-docs/doc-by-view/" + docId);
    };
    /**
     * Update a privacy studio doc
     *
     * @since 1.0.0
     *
     * @param data PrivacyStudioDoc data
     * @returns Observable<any>
     */
    PrivacyStudioDocsService.prototype.update = function (companyId, docId, data) {
        return this.apiService.apiCall("PATCH", "companies/privacy-studio-docs/" + companyId + "/" + docId, data);
    };
    /**
     * Delete a privacy studio doc
     *
     * @since 1.0.0
     *
     * @param data PrivacyStudioDoc data
     * @returns Observable<any>
     */
    PrivacyStudioDocsService.prototype.delete = function (companyId, docId) {
        return this.apiService.apiCall("DELETE", "companies/privacy-studio-docs/" + companyId + "/" + docId);
    };
    /**
     * Get an exportation file of all privacy studio docs
     *
     * @since 1.0.0
     */
    PrivacyStudioDocsService.prototype.getExport = function (companyId) {
        var _this = this;
        return this.apiService.apiCall('GET', "companies/privacy-studio-docs/export/" + companyId, {}, { responseType: 'blob' })
            .pipe(catchError(function (err) {
            return _this.helperService.parseErrorBlob(err);
        }));
    };
    PrivacyStudioDocsService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function PrivacyStudioDocsService_Factory() { return new PrivacyStudioDocsService(i0.ɵɵinject(i1.ApiService), i0.ɵɵinject(i2.HelperService)); }, token: PrivacyStudioDocsService, providedIn: "root" });
    return PrivacyStudioDocsService;
}());
export { PrivacyStudioDocsService };
